import type { ReactNode } from 'react'

type Tone = 'default' | 'brand' | 'ok' | 'warn' | 'danger'

const TONES: Record<Tone, string> = {
  default: 'bg-surface-2 text-muted border-line',
  brand: 'bg-brand-50 text-brand-700 border-brand-200',
  ok: 'bg-ok-soft text-ok border-ok/25',
  warn: 'bg-warn-soft text-warn border-warn/25',
  danger: 'bg-danger-soft text-danger border-danger/25',
}

export function Badge({ tone = 'default', children }: { tone?: Tone; children: ReactNode }) {
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-medium ${TONES[tone]}`}
    >
      {children}
    </span>
  )
}
